import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { BottomBarButton } from '@rd/types';

@Component({
  selector: 'rd-shared-bottom-bar',
  templateUrl: './bottom-bar.component.html',
  styleUrls: ['./bottom-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BottomBarComponent implements OnInit {
  @HostBinding('class.rd-shared-bottom-bar') componentClass = true;
  @Input() actionButtons: BottomBarButton[];

  constructor(private iconRegistryService: IconRegistryService) {}

  ngOnInit(): void {
    this.registerIcons();
  }

  iconize(icon: string): string {
    return `icon-${icon}`;
  }

  private registerIcons(): void {
    this.actionButtons.map(({ icon }) =>
      this.iconRegistryService.registerIcon(icon),
    );
  }
}
